export { default } from './IntersectionObserverPolyfill'
